import { useEffect, useState } from "react";
import { optionsArrrayWithOneParam } from "../../utils/buildOptionsArray";

const useAgreements = (getAgreements, active = 1) => {
  const [agreementOptionsArray, setAgreementsOptionsArray] = useState([]);
  useEffect(() => {
    (async () => {
      try {
        const agreements = await getAgreements(1);
        setAgreementsOptionsArray(
          optionsArrrayWithOneParam(agreements.filter((v) => active == null || v.active == active), "id", "description")
        );
      } catch (e) {}
    })();
  }, []);
  return agreementOptionsArray;
};

export default useAgreements;
